import { loadable } from 'nordic/lazy';
import PropTypes from 'prop-types';
import lazyComponentLoader from '../../utils/lazyComponentLoader';
import { iconList } from './icon-list';
import isValidIconElement from '../../utils/is-valid-icon-element';
import withLog from './helpers/with-log';

const LoadableIconWrapper = ({ id, fallbackIcon, ...restProps }) => {
  const LoadedIcon = isValidIconElement(Object.values(iconList), id)
    ? loadable(() => lazyComponentLoader(() => import(`./${id}`)))
    : withLog(fallbackIcon, {
        message: `Icon "${id}" not found. Verify component file name in app/components/icons and its registration in app/components/icons/icon-list.js`,
      });

  return <LoadedIcon {...restProps} />;
};

LoadableIconWrapper.propTypes = {
  id: PropTypes.string,
  fallbackIcon: PropTypes.func,
};

export default LoadableIconWrapper;
